import React from "react";
import label from "../services/Translation/lang";
import oddHolder from "../model/odd-holder";

// components/Modal.js
export default function PaytableModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-holder">
      <div className="modal-content">
        <p className="mb-0 w-100 text-center">{label.t("paytable_modal_1")}</p>
        <p className="mb-4 w-100 text-center">{label.t("paytable_modal_2")}</p>
        <div className="game-rules-table">
          <table>
            <thead>
              <tr>
                <th>{label.t("position")}</th>
                <th>{label.t("multiplier_value")}</th>
              </tr>
            </thead>
            <tbody>
              {oddHolder.slice(5, 20).map((ball, index) => {
                return (
                  <tr key={index}>
                    <td>{ball.position}</td>
                    <td>{ball.odd}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>{label.t("position")}</th>
                <th>{label.t("multiplier_value")}</th>
              </tr>
            </thead>
            <tbody>
              {oddHolder.slice(20, oddHolder.length).map((ball, index) => {
                return (
                  <tr key={index}>
                    <td>{ball.position}</td>
                    <td>{ball.odd}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <button onClick={onClose} className="close-modal">
          OK
        </button>
      </div>
    </div>
  );
}
